import React from 'react'

const Icon = ({ name }) => (
    <i className={name} aria-hidden="true"></i>
)
export default Icon